<app-layout>
    <h1 class="mb-8 font-bold text-3xl">Vouchers</h1>
    <div class="mb-6 flex justify-between items-center">
        <nav-button-link :href="route('admin.vouchers.create')">
            <span>Add</span>
            <span class="hidden md:inline">&nbsp;new voucher</span>
        </nav-button-link>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
        <table class="w-full whitespace-no-wrap">
            <tr class="text-left font-bold">
                <th class="px-6 pt-6 pb-4">Voucher Code</th>
                <th class="px-6 pt-6 pb-4">Amount</th>
                <th class="px-6 pt-6 pb-4">User ID</th>
                <th class="px-6 pt-6 pb-4">Status</th>
            </tr>
            <tr v-for="voucher in vouchers.data" :key="voucher.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t">
                    <inertia-link :href="route('admin.vouchers.edit', voucher.id)" class="px-6 py-4 flex items-center text-indigo-500">
                        {{ voucher.code }}
                    </inertia-link>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ voucher.amount }} {{ voucher.currency.symbol }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center">
                        {{ voucher.user_id }}
                    </span>
                </td>
                <td class="border-t">
                    <span class="px-6 py-4 flex items-center focus:text-indigo-500">
                        <badge class="mr-2" :type="!voucher.is_redeemed ? 'green' : 'gray'">
                            {{ !voucher.is_redeemed ? 'Active' : 'Reedemed' }}
                        </badge>
                    </span>
                </td>
            </tr>
            <tr v-if="vouchers.data.length === 0">
                <td class="border-t px-6 py-2" colspan="100">No Vouchers found.</td>
            </tr>
        </table>
    </div>
    <pagination :links="vouchers.links" />
</app-layout>
